module.exports = __webpack_public_path__ + "static/media/dnc_users.dc8399c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/dnc_users.svg
// module id = 2705
// module chunks = 0